import { useMemo } from 'react';
import { isAfter, isBefore } from 'date-fns';
import { getDateRange, normalizeEffectiveDate } from '~/components/BillClientModal/BillingDate/BillingDate.utils';
import { useIoContext } from '~/providers/IoContext';
export const useIssueDateValidation = (param)=>{
    let { effectiveDate, earliestBillableDate, mode } = param;
    const { getNow } = useIoContext();
    const { minDate, maxDate } = useMemo(()=>{
        return getDateRange(mode, getNow(), normalizeEffectiveDate(effectiveDate), earliestBillableDate);
    }, [
        mode,
        effectiveDate,
        earliestBillableDate
    ]);
    const validationRules = {
        validate (value) {
            const isInvalid = !value || !!minDate && isBefore(value, minDate) || !!maxDate && isAfter(value, maxDate);
            return !isInvalid || 'Invalid date';
        }
    };
    return {
        validationRules,
        maxDate,
        minDate
    };
};
